import React from 'react';

interface LogoProps {
    className?: string;
    size?: 'sm' | 'md';
}

/** AutomateIT.ng wordmark with a bolt-in-hexagon automation mark. */
const Logo: React.FC<LogoProps> = ({ className = '', size = 'md' }) => {
    const box = size === 'sm' ? 'w-8 h-8' : 'w-10 h-10';
    const text = size === 'sm' ? 'text-lg' : 'text-xl';
    return (
        <a href="#top" className={`group flex items-center gap-2.5 ${className}`} aria-label="AutomateIT.ng home">
            <span
                className={`relative ${box} rounded-xl bg-gradient-to-br from-brand-cyan to-brand-blue grid place-items-center shadow-glow-blue overflow-hidden`}
            >
                <span className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent" />
                <svg viewBox="0 0 24 24" fill="none" className="relative w-5 h-5 text-white">
                    <path
                        d="M13 2 4 13h6l-1 9 9-11h-6l1-9Z"
                        fill="currentColor"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinejoin="round"
                    />
                </svg>
            </span>
            <span className={`${text} font-display font-bold text-white tracking-tight`}>
                AutomateIT<span className="text-brand-cyan">.ng</span>
            </span>
        </a>
    );
};

export default Logo;
